// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import {
  createChecklist,
  createChecklistItem,
  deleteChecklist,
  deleteChecklistItem,
  getChecklist,
} from './checklistThunk';

export interface IChecklistState {
  isRefreshChecklistList: boolean;
}

export const initialState: IChecklistState = {
  isRefreshChecklistList: false,
};

const checklistSlice = createSlice({
  name: 'checklist',
  initialState,
  reducers: {
    setRefreshChecklistList(state, action) {
      state.isRefreshChecklistList = action.payload;
    },
  },
  extraReducers: (builder) => {
    // GET: Get checklist
    builder
      .addCase(getChecklist.pending, (_state) => {})
      .addCase(getChecklist.fulfilled, (_state) => {})
      .addCase(getChecklist.rejected, (_state) => {});

    // POST: Create checklist
    builder
      .addCase(createChecklist.pending, (_state) => {})
      .addCase(createChecklist.fulfilled, (_state) => {})
      .addCase(createChecklist.rejected, (_state) => {});

    // DELETE: delete checklist
    builder
      .addCase(deleteChecklist.pending, (_state) => {})
      .addCase(deleteChecklist.fulfilled, (_state) => {})
      .addCase(deleteChecklist.rejected, (_state) => {});

    // POST: Create checklist item
    builder
      .addCase(createChecklistItem.pending, (_state) => {})
      .addCase(createChecklistItem.fulfilled, (_state) => {})
      .addCase(createChecklistItem.rejected, (_state) => {});

    // DELETE: delete checklist item
    builder
      .addCase(deleteChecklistItem.pending, (_state) => {})
      .addCase(deleteChecklistItem.fulfilled, (_state) => {})
      .addCase(deleteChecklistItem.rejected, (_state) => {});
  },
});

// Action
export const checklistActions = checklistSlice.actions;

// Selectors

// Reducer
const checklistReducer = checklistSlice.reducer;
export default checklistReducer;
